module.exports = __webpack_public_path__ + "static/img/s6.f8287b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/s6.png
// module id = faUy
// module chunks = 0